import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Balance } from './balance'

export class BalancesRepository extends BaseRepository<Balance> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'balances', token, cache)
    }
}
